import { takeLatest, put, select } from 'redux-saga/effects';
import {
  UNINSTALL_CATEGORY_LIST,
  UNINSTALL_MIX_BATCH_DETAILS,
  USER_BACKUP_APP_83,
} from '../config';
import { createAxios, logNative } from '../utils/utils';

import {
  SET_UNINSTALL_CATEGORY,
  GET_UNINSTALL_CATEGORY,
  SET_MIX_BATCH_DETAILS,
  GET_MIX_BATCH_DETAILS,
  STOP_SCAN_RESIDUAL,
  SET_TEMP_RRSIDUAL_LIST,
  SET_RRSIDUAL_LIST,
  CANCEL_UNINSTALL,
  ADD_TEMP_RESIDUAL_SUCC,
  ADD_TEMP_RESIDUAL,
  STOP_DELETE_RESIDUAL,
  MODIFY_RESIDUAL_DATA,
  GET_RESIDUAL_MIX_BATCH_DETAILS,
  GET_APP_LIST,
  SET_APP_LIST_LOADING,
  SET_APP_LIST,
} from '../constants/unintall';
import { REMOVE_UNINSTALL_SOFT } from '../constants/native';
import { PCStoreJsBridge } from '../nativeapi/index';

/**
 * 获取我的软件分类
 */
function* fetchCategoryList() {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(UNINSTALL_CATEGORY_LIST);
    if (res.data.status === 0) {
      yield put({
        type: SET_UNINSTALL_CATEGORY,
        payload: res.data.data || [],
      });
    }
  } catch (error) {
    logNative('获取我的软件标签分类失败 fetchCategory', error);
  }
}

export function* watchFetchCategoryList() {
  yield takeLatest(GET_UNINSTALL_CATEGORY, fetchCategoryList);
}

/**
 * 获取我的软件详情（包含分类信息）
 */
function* fetchSoftsDetail(params) {
  const softsDetail = yield select(state => state.uninstall.softsDetail);
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(UNINSTALL_MIX_BATCH_DETAILS, {
      ...params.payload.params,
    });
    if (res.data.status === 0) {
      const deleteSoft = softsDetail.filter(item => {
        return !(res.data.data && res.data.data.find(soft => soft.softID === item.softID));
      });
      yield put({
        type: SET_MIX_BATCH_DETAILS,
        payload: {
          softsDetail: [...res.data.data, ...deleteSoft] || [...deleteSoft],
        },
      });
    }
  } catch (error) {
    logNative('获取我的软件详情失败 fetchSoftsDetail', error);
  }
}

export function* watchFetchSoftsDetail() {
  yield takeLatest(GET_MIX_BATCH_DETAILS, fetchSoftsDetail);
}

/**
 * 获取残留软件详情（包含分类信息）
 */
function* fetchResidualSoftsDetail(params) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(UNINSTALL_MIX_BATCH_DETAILS, {
      ...params.payload.params,
    });
    if (res.data.status === 0) {
      // params.payload.callback(res.data.data || []);
      yield put({
        type: SET_MIX_BATCH_DETAILS,
        payload: {
          residualDetail: res.data.data || [],
        },
      });
    }
  } catch (error) {
    logNative('获取我的软件详情失败 fetchSoftsDetail', error);
  }
}

export function* watchFetchResidualSoftsDetail() {
  yield takeLatest(GET_RESIDUAL_MIX_BATCH_DETAILS, fetchResidualSoftsDetail);
}

/**
 * 停止扫描超长的文件
 */

function* stopScanResidual(params) {
  // 在临时文件中找到该残留文件
  const uninstall = yield select(state => {
    return state.uninstall;
  });
  const { tempResidualList } = uninstall;
  const { residualList } = uninstall;
  // eslint-disable-next-line no-case-declarations
  const tartgetTemp =
    tempResidualList && tempResidualList.find(item => item.softGUID === params.payload.softGUID);
  const target =
    residualList && residualList.find(item => item.softGUID === params.payload.softGUID);
  // eslint-disable-next-line no-case-declarations
  if ((tartgetTemp && tartgetTemp.status === 'SCANING') || params.payload.status === 'SCANING') {
    PCStoreJsBridge.stopScanSoftwareResidual({ softGUID: params.payload.softGUID });
    const tmp = tempResidualList.filter(item => item.softGUID !== params.payload.softGUID);
    if (tartgetTemp) {
      yield put({
        type: SET_TEMP_RRSIDUAL_LIST,
        payload: tmp,
      });
      yield put({
        type: REMOVE_UNINSTALL_SOFT,
        result: tartgetTemp,
      });
      yield put({
        type: CANCEL_UNINSTALL,
        soft: tartgetTemp,
      });
    }
    const temp = residualList.filter(item => item.softGUID !== params.payload.softGUID);
    if (target) {
      yield put({
        type: SET_RRSIDUAL_LIST,
        payload: temp,
      });
    }
  }
}

export function* watchStopScanResidual() {
  yield takeLatest(STOP_SCAN_RESIDUAL, stopScanResidual);
}

function* addTempResidual({ payload }) {
  const installSofts = yield select(state => state.native.installedSoft);
  const target = installSofts.find(
    item => item.softGUID === payload.softGUID && item.androidType !== '1',
    // &&
    // item.isx64 === payload.isx64,
  );
  if (target) {
    yield put({
      type: ADD_TEMP_RESIDUAL_SUCC,
      payload: {
        ...target,
        ...payload,
      },
    });
  }
  // ADD_TEMP_RESIDUAL_REQ
}

export function* watchAddTempResidual() {
  yield takeLatest(ADD_TEMP_RESIDUAL, addTempResidual);
}

// STOP_DELETE_RESIDUAL  停止删除残留文件

function* stopDeleteResidual({ payload }) {
  const uninstall = yield select(state => state.uninstall);
  const list = [...uninstall.tempResidualList, ...uninstall.residualList];
  const target = list.find(item => item.softGUID === payload.softGUID);
  if (target && target.status === 'LOADING') {
    PCStoreJsBridge.stopScanSoftwareResidual(target);
    yield put({
      type: MODIFY_RESIDUAL_DATA,
      payload: {
        status: 'CLEAR_ERR',
        softGUID: target.softGUID,
      },
    });
  }
}
export function* watchStopDeleteResidual() {
  yield takeLatest(STOP_DELETE_RESIDUAL, stopDeleteResidual);
}

function* getAppList({ payload }) {
  yield put({
    type: SET_APP_LIST_LOADING,
    loading: true,
  });
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(USER_BACKUP_APP_83);
    if (res.data.status === 0) {
      let arr = res.data.data.map(item => {
        return {
          ...item,
          SoftID: item.softID,
        };
      });
      yield put({
        type: SET_APP_LIST,
        payload: {
          list: arr,
        },
      });
    }
    yield put({
      type: SET_APP_LIST_LOADING,
      loading: false,
    });
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}

export function* watchGetAppList() {
  yield takeLatest(GET_APP_LIST, getAppList);
}
